import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CAMPAIGN_ANNOUNCE_REWARD =
  "paginationCampaignAnnounceReward";
export const GET_CAMPAIGN_ANNOUNCE_REWARD = "getCampaignAnnounceReward";
export const FIND_CAMPAIGN_ANNOUNCE_REWARD = "findCampaignAnnounceReward";
export const CREATE_CAMPAIGN_ANNOUNCE_REWARD = "createCampaignAnnounceReward";
export const UPDATE_CAMPAIGN_ANNOUNCE_REWARD = "updateCampaignAnnounceReward";
export const DELETE_CAMPAIGN_ANNOUNCE_REWARD = "deleteCampaignAnnounceReward";

// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "campaign_announce_reward",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: false,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CAMPAIGN_ANNOUNCE_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [GET_CAMPAIGN_ANNOUNCE_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`, {
        params: payload.params
      });
    },
    [FIND_CAMPAIGN_ANNOUNCE_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.get(`${context.state.path}`, payload.id);
    },
    [CREATE_CAMPAIGN_ANNOUNCE_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [UPDATE_CAMPAIGN_ANNOUNCE_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [DELETE_CAMPAIGN_ANNOUNCE_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: false,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
